import React from 'react'
import "./Logo.css";

export default function Logo() {
    return (
        <div className='logo-holder'>
            <img
                src={
                    process.env.PUBLIC_URL + "/assets/Images/Logo/printout_logo.png"
                }
                className="logo_img"
                alt="logo_img"
            />
        </div>
    )
}
